import ClientBalanceEnum from '~/enums/ClientBalanceEnum'
import { getFullTime, getFullYear } from '~/utils/date/parseDate'
import type { FrontendBalanceHistoryRecord } from '~/types/balance/balanceFrontendTypes'

export default function formatBalanceHistoryItems(items: FrontendBalanceHistoryRecord[]) {
  return items.map((item: FrontendBalanceHistoryRecord) => {
    return formatRecord(item)
  })
}

function formatRecord(record: FrontendBalanceHistoryRecord) {
  return {
    id: 'ID' + record.id,
    type: getTransactionTypeText(record.rel_type, record.type, record.rel_id),
    order_nr: getOrderNo(record),
    order_nr_link: getOrderNoLink(record),
    payment_processor: getPaymentProcessorName(record.rel_type, record.payment_processor_name),
    date: getFullYear(record.created_at) + ' ' + getFullTime(record.created_at),
    starting_balance: record.starting_balance,
    ending_balance: record.end_balance,
    amount: record.amount,
  }
}

function getTransactionTypeText(relType: number, type: number, relId: number) {
  if (!relId) {
    switch (relType) {
      case ClientBalanceEnum.relTypeQuote:
        return 'balance.balance_refund_for_quote'
      case ClientBalanceEnum.relTypeForwardRequest:
        return 'balance.balance_refund_for_forward_request'
    }
  }

  switch (relType) {
    case ClientBalanceEnum.relTypeMiscInvoice:
      return 'balance.balance_paid_for_misc_invoice'
    case ClientBalanceEnum.relTypeQuote:
      return 'balance.balance_paid_for_quote'
    case ClientBalanceEnum.relTypeForwardRequest:
      return 'balance.balance_paid_for_forward_request'
    case ClientBalanceEnum.relTypeManualTopUpByAdmin:
      switch (type) {
        case ClientBalanceEnum.typeAddition:
          return 'balance.balance_manual_top_up_by_admin'
        case ClientBalanceEnum.typeDeduction:
          return 'balance.balance_manual_deduction_by_admin'
        default:
          return ''
      }
    case ClientBalanceEnum.relTypeBalanceTopUp:
      return 'balance.balance_top_up'
    default:
      return ''
  }
}

function getOrderNo(record: FrontendBalanceHistoryRecord) {
  switch (record.rel_type) {
    case ClientBalanceEnum.relTypeQuote:
      return record.rel_id ? 'QU' + record.rel_id : null
    case ClientBalanceEnum.relTypeForwardRequest:
      return record.rel_id ? 'FR' + record.rel_id : null
    case ClientBalanceEnum.relTypeBalanceTopUp:
      return record.payment_processor_transaction_id
    default:
      return null
  }
}

function getOrderNoLink(record: FrontendBalanceHistoryRecord) {
  const result = null

  if (record.rel_type === ClientBalanceEnum.relTypeQuote) {
    if (record.quote_slug) {
      // TODO set result link to order summary page
    }
  } else if (record.rel_type === ClientBalanceEnum.relTypeForwardRequest) {
    // TODO set result link to shipment summary page
  }

  return result
}

function getPaymentProcessorName(relType: number, payment_processor_name: string | null) {
  return relType === ClientBalanceEnum.relTypeBalanceTopUp ? payment_processor_name : null
}
